import { createColumnHelper } from '@tanstack/react-table';
import { formatDate } from '../../../utils/helpers';
import { IAccounts } from './accounts-utils';
import AccountsActionButton from './AccountsActionsButtons';
import Chip from '@mui/material/Chip';
import { ILocation } from '../../DatabaseManagement/OtherDBs/Location/utils/Location-utils';

const columnHelper = createColumnHelper<IAccounts>();

const accountsColumns = [
  columnHelper.accessor((row) => `${row.firstName} ${row.lastName}`, {
    id: 'fullName',
    header: 'Name',
    cell: (row) => row.getValue(),
    enableColumnFilter: false,
  }),
  columnHelper.accessor('roleName', {
    id: 'roleName',
    header: 'Role',
    cell: (row) => row.renderValue(),
    enableGlobalFilter: true,
    enableColumnFilter: true,
  }),
  columnHelper.accessor('isActive', {
    id: 'isActive',
    header: 'Status',
    cell: (row) => (row.getValue() ? 'Active' : 'Inactive'),
    enableGlobalFilter: true,
    enableColumnFilter: true,
  }),

  columnHelper.accessor('dateCreated', {
    id: 'dateCreated',
    header: 'Date Created',
    cell: ({ row }) => formatDate(row.original.dateCreated),
    enableGlobalFilter: true,
    enableColumnFilter: true,
  }),
  columnHelper.accessor('dateUpdated', {
    id: 'dateUpdated',
    header: 'Date Updated',
    cell: ({ row }) => formatDate(row.original.dateUpdated),
    enableGlobalFilter: true,
    enableColumnFilter: true,
  }),

  columnHelper.display({
    id: 'actions',
    header: 'Action',
    cell: ({ row }) => <AccountsActionButton userAccount={row.original} />,
    enableHiding: false,
  }),
];

export default accountsColumns;


export const getAccountsColumns = (
  userProjectsMap: Map<string, ILocation[]>,
  onOpenProjects?: (account: IAccounts, userProjects: ILocation[], position: { top: number; left: number }) => void
) => [
  columnHelper.accessor((row) => `${row.firstName} ${row.lastName}`, {
    id: 'fullName',
    header: 'Name',
    cell: (row) => row.getValue(),
    enableColumnFilter: false,
  }),
  columnHelper.accessor('roleName', {
    id: 'roleName',
    header: 'Role',
    cell: (row) => row.renderValue(),
    enableGlobalFilter: true,
    enableColumnFilter: true,
  }),
  columnHelper.display({
    id: 'totalProjects',
    header: 'Total Project',
    cell: ({ row }) => {
      const userProjects = userProjectsMap.get(row.original.id) || [];
      const count = userProjects.length;
      return (
        <Chip
          label={`${count} ${count === 1 ? 'Project' : 'Projects'}`}
          color="primary"
          variant="outlined"
          onClick={(e) => {
            e.stopPropagation();
            const rect = e.currentTarget.getBoundingClientRect();
            onOpenProjects?.(row.original, userProjects, {
              top: rect.bottom + 6,
              left: rect.left + rect.width / 2,
            });
          }}
          sx={{ cursor: 'pointer', height: '25px', fontWeight: 500 }}
        />
      );
    },
    enableHiding: false,
  }),
  columnHelper.accessor('isActive', {
    id: 'isActive',
    header: 'Status',
    cell: (row) => (row.getValue() ? 'Active' : 'Inactive'),
    enableGlobalFilter: true,
    enableColumnFilter: true,
  }),
  columnHelper.accessor('dateCreated', {
    id: 'dateCreated',
    header: 'Date Created',
    cell: ({ row }) => formatDate(row.original.dateCreated),
    enableGlobalFilter: true,
    enableColumnFilter: true,
  }),
  columnHelper.accessor('dateUpdated', {
    id: 'dateUpdated',
    header: 'Date Updated',
    cell: ({ row }) => formatDate(row.original.dateUpdated),
    enableGlobalFilter: true,
    enableColumnFilter: true,
  }),
  columnHelper.display({
    id: 'actions',
    header: 'Action',
    cell: ({ row }) => <AccountsActionButton userAccount={row.original} />,
    enableHiding: false,
  }),
];

